/**
 * Generate the HTML for selected billing address and replace the old one
 * @param {Object} data - the `data` that comes from the response
 */
const defineHTMLForSelectedBilling = data => {
    const selectedBillingAddressElement = document.querySelector(".js-billing-address-selected");
    if (selectedBillingAddressElement === undefined) { return; }

    if (data?.billingAddress === undefined) { return; }

    const { title, address1, address2, door, floor, side, zipCode, city, council } = data?.billingAddress;

    const selectedBillingAddressHTML = `
        <p class="billing-step--address-name">
            ${title === null || title === undefined ? "" : title}
        </p>
        <p class="billing-step--address-details">
            ${address1 === null || address1 === undefined ? "" : address1}
            ${address2 === null || address2 === undefined ? "" : address2}
            ${door === null || door === undefined ? "" : door}
            ${floor === null || floor === undefined ? "" : floor}
            ${side === null || side === undefined ? "" : side}
            ${zipCode === null || zipCode === undefined ? "" : zipCode}
            ${city === null || city === undefined ? "" : city}
            ${council === null || council === undefined ? "" : council}
        </p>
    `;

    selectedBillingAddressElement.innerHTML = selectedBillingAddressHTML;
};

export { defineHTMLForSelectedBilling };
